import React from "react";
import { Link } from "react-router-dom";

const IMG_BASE_URL = process.env.REACT_APP_IMG_URL;

function Footer() {
  return (
    <footer className="bg-black bg-opacity-90 text-white px-4 py-6">
      <div className="max-w-5xl mx-auto text-center space-y-4">

        {/* Réseaux sociaux */}
        <div className="flex justify-center space-x-6">
          <a
            href="https://www.facebook.com/leftmyfootprint"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${IMG_BASE_URL}/storage/images/front/LOGOFB.png`}
              alt="Facebook"
              className="h-10 w-10 hover:scale-110 transition"
            />
          </a>

          <a
            href="https://www.instagram.com/lmfp_photography?igsh=MW04bDYxaDh6c2Mzcg=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${IMG_BASE_URL}/storage/images/front/LOGOINSTA.png`}
              alt="Instagram"
              className="h-10 w-10 hover:scale-110 transition"
            />
          </a>
        </div>

        {/* Liens légaux */}
        <div className="flex justify-center gap-6 text-sm text-gray-400">
          <Link to="/cgu" className="hover:text-white transition">
            CGU
          </Link>
          <Link to="/confidentialite" className="hover:text-white transition">
            Confidentialité
          </Link>
        </div>

        {/* Message */}
        <p className="text-sm text-gray-400">
          💬 Ce site évolue constamment — vos retours sont les bienvenus via le formulaire de contact.
        </p>

        {/* Copyright + dev */}
        <div className="text-xs text-gray-500 space-y-1">
          <p>&copy; {new Date().getFullYear()} LMFP Photography. Tous droits réservés.</p>
          <p>
            Site réalisé par{" "}
            <a
              href="https://www.benjaminschroeders.be"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white underline underline-offset-4 transition"
            >
              Schroeders Benjamin
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;